import { Box, Link, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { CompanyComment } from "models/CompanyComment";
import { formatDateTime } from "utilities/formatDateTime";
import { PriorityHigh } from "@mui/icons-material";

type CommentItemProps = { comment: CompanyComment };

const CommentItem: React.FC<CommentItemProps> = (props) => {
  const { comment } = props;

  return (
    <ListItem divider sx={{ ...(comment.important && { bgcolor: "background.error" }) }}>
      {comment.important && (
        <ListItemIcon>
          <PriorityHigh sx={{ fontSize: "2rem", color: "error.main" }} />
        </ListItemIcon>
      )}

      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gap={0.5}>
            <Link component={RouterLink} to={`/users/view/${comment.createdBy.id}`}>
              {comment.createdBy.userName}
            </Link>

            <Typography fontSize="small" ml="auto">
              {formatDateTime(comment.createdAt)}
            </Typography>
          </Box>
        }
        secondary={
          <Typography
            component="pre"
            sx={{
              whiteSpace: "break-spaces",
              overflowWrap: "anywhere",
              width: "fit-content",
              mt: 1,
              flexGrow: 1,
            }}
          >
            {comment.commentText}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default CommentItem;
